// Colors

const neutral = {
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#1a1a1a'
}

//https://www.learnui.design/tools/data-color-picker.html
const charts = {
    paperBackgroundColor: '#222222',
    header: {
        divider: {
            borderColor: '#666666',
            marginTop: '16px',
            marginBottom: '16px'
        },
        dividerAfter: {
            borderColor: '#666666'
        },
        dividerBefore: {
            borderColor: '#666666'
        },
        dividerHeadline: {
            fontSize: 24,
            color: '#fff',
            fontWeight: 700
        },
        dividerSubHeadline: {
            display: 'block',
            fontSize: 14,
            color: '#999999',
            fontWeight: 400,
            paddingBottom: 16
        }
    },
    description: {
        textColor: '#999999'
    },
    colorSeries: {
        textColor: '#ffffff',
        primary: [
            '#db6757',
            '#e89688',
            '#f0c3bb',
            '#f1f1f1',
            '#f0b8b8',
            '#e67f83',
            '#d43d51'
        ],
        secondary: [
            '#70a0fa',
            '#a2baf8',
            '#cbd5f4',
            '#f1f1f1',
            '#f0b8b8',
            '#e67f83',
            '#d43d51'
        ],
        alternative1: [
            '#63a15c',
            '#99c591',
            '#abd1a4',
            '#bddeb6',
            '#cfeac9',
            '#87b97f',
            '#75ad6e'
        ],
        alternative2: [
            '#dbd257',
            '#ded569',
            '#e2d87b',
            '#e4da8c',
            '#e7dd9c',
            '#e9e0ad',
            '#eae3bd'
        ]
    },
    scorecard: {
        boxShadow: '#000 1px 1px 2px',
        backgroundColor: '#222222',
        title: {
            textColor: '#ffff08'
        },
        value: {
            textColor: '#ffffff'
        },
        infoIcon: {
            color: '#aaaaaa'
        }
    },
    barChart: {
        axis: {
            line: {
                stroke: '#666666'
            },
            tick: {
                stroke: '#666666'
            }
        },
        label: {
            fill: '#ffffff'
        },
        tickLabel: {
            fill: '#ffffff'
        }
    },
    pieChart: {
        pieArc: {
            stroke: '#222222'
        }
    },
    placeholder: {
        backgroundColor: '#222222',
        skeleton: {
            backgroundColor: '#444444'
        }
    },
    noData: {
        icon: {
            textColor: '#5C94EE'
        },
        text: {
            textColor: '#cccccc'
        }
    },

    filter: {
        label: {
            textColor: '#cccccc'
        },
        autocomplete: {
            backgroundColor: '#222222',
            borderColor: '#222222',
            tagsSizeNo: {
                color: '#ffffff'
            },
            input: {
                textColor: '#ffffff'
            },
            options: {
                backgroundColor: '#fff !important'
            },
            optionsSeparator: {
                borderTop: '1px solid #eee'
            },
            optionsHover: {
                backgroundColor: '#eee'
            }
        }
    },
    table: {
        root: {
            backgroundColor: '#222222',
            color: '#4da1ff'
        },
        headTh: {
            backgroundColor: '#222222'
        },
        bodyTd: {
            borderColor: '#666666'
        }
    }
}

const reports = {
    MuiAutocomplete: {
        p: 0,
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        borderTop: '1px solid #666666',
        '&.MuiAutocomplete-option': {
            alignItems: 'flex-start',
            color: '#fff',
            backgroundColor: '#3a3e43 !important',
            '&:hover': {
                backgroundColor: '#53575d !important'
            },
            '&.Mui-focused': {
                backgroundColor: '#53575d !important'
            }
        },
        root: {
            backgroundColor: '#3a3e43'
        },
        backgroundColor: '#3a3e43',

        color: '#fff'
    }
}

const custom = {
    navBar: {
        adminColor: '#222222'
    },
    dashboard: {
        backgroundColor: '#1a1a1a'
    },
    checkout: {
        paymentSummaryBg: '#ccc',
        borderColorLeft: '#222',
        borderColorRight: '#ccc',
        successBoxBg: '#dddddd'
    },
    text: {
        lightGrey: '#ced1d6',
        white: '#fff',
        hilightText: '#ffff08'
    },
    reports: {
        headlineColor: '#b7c2cf',
        filterBg: '#222222',
        inputBg: '#000000',
        textColor: '#ffffff',
        borderColor: '#ffffff'
    },
    paperRadius: {
        main: {
            borderRadius: 30
        },
        secondary: {
            borderRadius: 2
        }
    },
    selectionBox: {
        borderRadius: 3,
        bgColor: '#ffffff',
        textColor: '#000000',
        iconColor: '#20406c'
    },
    stepperText: {
        main: '#9f3a3a',
        active: '#ffffff',
        completed: '#ffffff'
    },
    stepperLabel: {
        main: '#9f3a3a',
        active: '#ffc107',
        completed: '#3a9f60'
    },
    stepperBg: {
        main: '#e18b5b',
        active: '#ffc107',
        completed: '#3a9f60'
    },
    stepperBorder: {
        main: '#9f3a3a',
        active: '#ffc107',
        completed: '#3a9f60'
    },

    campaignSummaryBg: {
        main: '#222',
        light: '#3e4a5c',
        dark: '#ffffff',
        contrastText: '#FFFFFF'
    },
    summaryCard: {
        bgColor: '#eee',
        bgColorActive: '#ffffff',
        bgColorHilighted: '#4f67bb',
        bgColorStats: '#222222',

        textColor: '#666666',
        textColorActive: '#000000',
        textColorHilighted: '#ffffff',

        headlineColor: '#858d98',
        headlineColorActive: '#8f8f8f',
        headlineColorHilighted: '#ffff08'
    },
    reportsCard: {
        bgColor: '#eee',
        bgColorActive: '#ffffff',
        bgColorHilighted: '#4f67bb',
        bgColorStats: '#222222',

        textColor: '#666666',
        textColorActive: '#000000',
        textColorHilighted: '#ffffff',

        headlineColor: '#858d98',
        headlineColorActive: '#8f8f8f',
        headlineColorHilighted: '#ffff08'
    },
    radioSelect: {
        bgColor: '#ececec',
        bgColorActive: '#000000',
        bgColorHover: '#5a616a',

        labelColor: '#000000',
        labelColorActive: '#ffffff',
        labelColorHover: '#ffffff',

        iconColor: '#20406c',
        iconColorActive: '#b7c2cf',
        iconColorHover: '#b7c2cf'
    },
    fileDropZone: {
        bgColor: '#444444',
        borderColor: '#AAAAAA',
        textColor: '#ffffff',
        borderColorError: '#f44336'
    },
    fileDropZonePreview: {
        bgColor: '#444444',
        borderColor: '#AAAAAA',
        textColor: '#ffffff'
    },

    campaignStatusState: {
        statusBg: {
            none: '#666666',
            draft: '#7e90a8',
            initiated: '#7e90a8',
            updated: '#7e90a8',

            waiting: '#ffff96',
            waiting_approval: '#ffff96',
            approved: '#5eedb1',
            wait_for_payment: '#ffff96',
            pending: '#ffff96',
            processing: '#ffff96',
            completed_partially: '#ffff96',
            ready: '#ffff96',

            dry_sync: '#ffc778',
            dsp_distributor: '#ffc778',
            scheduled: '#ffc778',
            live: '#5eedb1',
            completed_full: '#5eedb1',
            confirmed: '#5eedb1',

            error: '#d83030',
            failed: '#d83030',
            dsp_canceled: '#d83030',
            rejected: '#d83030',
            rejected_refund: '#d83030',
            rejected_payment: '#d83030',
            rejected_audit: '#d83030',
            deleted: '#d83030',

            canceled: '#d83030',
            completed: '#405d86',

            auth_credit: '#3a649f',
            stripe_ach: '#3a649f',
            stripe_cc: '#3a649f',
            unknown: '#d83030',

            approved_partially: '#ffa500',
            auth_credit_refund: '#ffa500'
        },
        statusText: {
            none: '#ffffff',
            draft: '#0b1b31',
            initiated: '#0b1b31',
            updated: '#0b1b31',

            waiting: '#0b1b31',
            waiting_approval: '#0b1b31',
            approved: '#0b1b31',
            wait_for_payment: '#0b1b31',
            pending: '#0b1b31',
            processing: '#0b1b31',
            completed_partially: '#0b1b31',
            ready: '#0b1b31',

            dry_sync: '#0b1b31',
            dsp_distributor: '#0b1b31',
            scheduled: '#0b1b31',
            live: '#0b1b31',
            completed_full: '#0b1b31',
            confirmed: '#0b1b31',

            failed: '#ffffff',
            error: '#ffffff',
            dsp_canceled: '#ffffff',
            rejected_refund: '#ffffff',
            rejected: '#ffffff',
            rejected_payment: '#ffffff',
            rejected_audit: '#ffffff',
            deleted: '#ffffff',

            canceled: '#ffffff',
            completed: '#ffffff',

            auth_credit: '#ffffff',
            stripe_ach: '#ffffff',
            stripe_cc: '#ffffff',
            unknown: '#ffffff',

            approved_partially: '#14110c',
            auth_credit_refund: '#14110c'
        }
    },

    campaignTable: {
        cardBg: '#222222',
        headerText: '#b7c2cf',
        dataText: '#ffffff',
        separatorLine: '#444444',
        moreButton: {
            bg: '#ffffff',
            bgHover: '#839cf4',
            text: '#000000',
            textHover: '#ffffff'
        },
        status: {
            processing: '#ffcf96',
            waiting_on_wire: '#ffb696',
            ready: '#ffff96',
            live: '#5eedb1',
            completed: '#405d86',
            draft: '#7e90a8',
            rejected: '#d83030'
        },
        statusBg: {
            none: '#666666',
            draft: '#7e90a8',

            waiting: '#ffff96',
            waiting_approval: '#ffff96',
            approved: '#ffff96',
            approved_partially: '#ffff96',
            wait_for_payment: '#ffff96',
            pending: '#ffff96',
            processing: '#ffff96',
            ready: '#ffff96',

            scheduled: '#ffc778',
            live: '#5eedb1',

            rejected_refund: '#d83030',
            rejected_payment: '#d83030',
            rejected_audit: '#d83030',
            rejected: '#d83030',
            deleted: '#cccccc',

            canceled: '#405d86',
            completed: '#405d86'
        },
        statusText: {
            none: '#ffffff',
            draft: '#0b1b31',

            waiting: '#0b1b31',
            waiting_approval: '#0b1b31',
            approved: '#0b1b31',
            approved_partially: '#0b1b31',
            wait_for_payment: '#0b1b31',
            pending: '#0b1b31',
            processing: '#0b1b31',
            ready: '#0b1b31',

            scheduled: '#0b1b31',
            live: '#0b1b31',

            rejected_refund: '#ffffff',
            rejected_payment: '#ffffff',
            rejected_audit: '#ffffff',
            rejected: '#ffffff',
            deleted: '#666666',

            canceled: '#ffffff',
            completed: '#ffffff'
        }
    },
    account: {
        backBgColor: '#000000',
        bgColor: '#ffffff',
        headlineColor: '#ffffff'
    },
    stripeStyles: {
        theme: 'stripe',
        variables: {
            colorPrimary: '#000',
            colorBackground: '#ffffff',
            colorText: '#000000',
            fontWeightNormal: 700,
            colorDanger: '#df1b41',
            fontFamily: 'Open Sans, system-ui, sans-serif',
            spacingUnit: '6px',
            borderRadius: '8px',
            focusBoxShadow: 'none'
            // See all possible variables below
        },

        rules: {
            '.Input': {
                border: '1px solid #ccc',
                boxShadow: 'none'
            },
            '.Label': {
                color: ''
            }
        }
    }
}

const alterntivePrimary = {
    main: '#555555',
    light: '#e18b5b',
    dark: '#e18b5b',
    alternative: '#b7c2cf',
    contrastText: '#FFFFFF'
}

const alterntiveSeccondary = {
    main: '#d83030',
    light: '#e18b5b',
    dark: '#a03333',
    alternative: '#dd4040',
    contrastText: '#FFFFFF'
}

const formback = {
    main: '#5a616a',
    light: '#d0d0d0',
    dark: '#e18b5b',
    contrastText: '#FFFFFF'
}

const formnext = {
    main: '#000000',
    light: '#d0d0d0',
    dark: '#e18b5b',
    contrastText: '#FFFFFF'
}

const background = {
    default: '#000000',
    paper: '#FFFFFF'
}

const divider = '#E6E8F0'

const primary = {
    main: '#555555',
    light: '#e18b5b',
    dark: '#000000',
    alternative: '#b7c2cf',
    contrastText: '#FFFFFF'
}

const radioCheckbox = {
    main: '#b7c2cf'
}

const secondary = {
    main: '#db1a1a',
    light: '#db1a1a',
    dark: '#db1a1a',
    contrastText: '#ffff'
}

const success = {
    main: '#14B8A6',
    light: '#43C6B7',
    dark: '#0E8074',
    contrastText: '#FFFFFF'
}

const info = {
    main: '#2196F3',
    light: '#64B6F7',
    dark: '#0B79D0',
    contrastText: '#FFFFFF'
}

const warning = {
    main: '#FFB020',
    light: '#FFBF4C',
    dark: '#B27B16',
    contrastText: '#FFFFFF'
}

const error = {
    main: '#D14343',
    light: '#DA6868',
    dark: '#922E2E',
    contrastText: '#FFFFFF'
}

const text = {
    primary: '#000000',
    secondary: '#000000',
    disabled: 'rgba(0, 0, 0, 0.48)'
}

export const themeOptions = {
    components: {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: custom.radioSelect.iconColorActive
                    }
                }
            }
        },

        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    '&.Mui-disabled': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    // "&.Mui-disabled": {
                    //   color: "#ffffff",
                    //   backgroundColor: "#ccc",
                    //   opacity: 0.5
                    // },
                }
            }
        },

        MuiStepLabel: {
            styleOverrides: {
                label: {
                    fontSize: 14,
                    fontWeight: 600,
                    color: custom.stepperLabel.main,
                    '&.MuiStepLabel-alternativeLabel': {
                        marginTop: 10
                    },
                    '&.Mui-active': {
                        color: custom.stepperLabel.active,
                        fontWeight: 800
                    },
                    '&.Mui-completed': {
                        color: custom.stepperLabel.completed
                    }
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: neutral[500],
                    color: '#FFFFFF'
                }
            }
        },

        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-filledDefault': {
                        backgroundColor: neutral[200],
                        '& .MuiChip-deleteIcon': {
                            color: neutral[400]
                        }
                    },
                    '&.MuiChip-outlinedDefault': {
                        '& .MuiChip-deleteIcon': {
                            color: neutral[300]
                        }
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: '#ccc'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    backgroundColor: '#ffffff',
                    borderColor: '#a0a0a0',
                    color: text.secondary,
                    '&::placeholder': {
                        opacity: 1,
                        color: '#bbb'
                    }
                },
                notchedOutline: {
                    borderColor: divider
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderColor: divider,
                    borderStyle: 'solid',
                    borderWidth: 1
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    borderColor: divider,
                    borderStyle: 'solid',
                    borderWidth: 1
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    color: neutral[500]
                },
                track: {
                    backgroundColor: neutral[400],
                    opacity: 1
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: 'none'
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    borderTop: `1px solid ${custom.campaignTable.separatorLine}`,
                    color: custom.campaignTable.dataText
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    '.MuiTableCell-root': {
                        borderTop: `1px solid ${custom.campaignTable.separatorLine}`,
                        color: custom.campaignTable.dataText
                    }
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '.MuiTableCell-root': {
                        color: custom.campaignTable.headerText,
                        fontWeight: 500,
                        textTransform: 'capitalize',
                        fontSize: 14,
                        backgroundColor: custom.campaignTable.cardBg
                    }
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    // scrollbarWidth: "thin",
                    // scrollbarColor: "#6b6b6b #2b2b2b",
                    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                        backgroundColor: 'transparent',
                        width: 6,
                        paddingTop: 10
                    },
                    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb':
                        {
                            borderRadius: 8,
                            backgroundColor: '#000000',
                            minHeight: 24
                            // borderLeft: "4px solid transparent",
                        },
                    '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner':
                        {
                            backgroundColor: '#174c86'
                        }
                }
            }
        },
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    // scrollbarWidth: "thin",
                    // scrollbarColor: "#6b6b6b #2b2b2b",
                    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                        backgroundColor: 'transparent',
                        width: 6,
                        paddingTop: 10
                    },
                    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb':
                        {
                            borderRadius: 8,
                            backgroundColor: '#000000',
                            minHeight: 24
                            // borderLeft: "4px solid transparent",
                        },
                    '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
                        {
                            backgroundColor: '#174c86'
                        },
                    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner':
                        {
                            backgroundColor: '#174c86'
                        }
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#000000'
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#ffffff !important'
                }
            }
        }
    },

    typography: {
        h2: {
            color: '#fff'
        },
        h4: {
            color: '#fff'
        },
        h5: {
            color: '#000000'
        },
        h6: {
            // color: "#ff3f3f",
        },
        body2: {
            // color: "#eeeeee",
        },
        subtitle1: {
            // color: "#c1c1c1",
        },
        subtitle2: {
            // color: "#a5a5a5",
        },
        overline: {
            // color: "#ff3f3f",
        }
    },
    palette: {
        action: {
            active: neutral[500],
            focus: 'rgba(55, 65, 81, 0.12)',
            hover: 'rgba(55, 65, 81, 0.04)',
            selected: 'rgba(55, 65, 81, 0.08)',
            disabledBackground: 'rgba(55, 65, 81, 0.12)',
            disabled: 'rgba(55, 65, 81, 0.26)'
        },
        background,
        divider,
        error,
        info,
        mode: 'light',
        neutral,
        primary,
        alterntivePrimary,
        alterntiveSeccondary,
        radioCheckbox,
        secondary,
        success,
        text,
        warning,
        custom,
        formback,
        formnext,
        reports
    },
    charts
}
